var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      staticClass: "overflow-visible",
      staticStyle: { "overflow-y": "hidden" },
      style: { background: _vm.$vuetify.theme.themes[_vm.theme].background }
    },
    [
      _c(
        "v-system-bar",
        {
          staticStyle: { position: "relative" },
          attrs: { height: _vm.POPUP_TOP_HEIGHT, color: _vm.color }
        },
        [
          _c(
            "div",
            [
              _vm.icon
                ? _c(
                    "v-btn",
                    {
                      staticClass: "pa-2",
                      staticStyle: {
                        "background-color": "white",
                        "z-index": "3",
                        "pointer-events": "none"
                      },
                      attrs: {
                        icon: "",
                        outlined: "",
                        "x-large": "",
                        color: _vm.color
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "ma-0", attrs: { color: _vm.color } },
                        [_vm._v(_vm._s(_vm.icon))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "text-uppercase",
                  staticStyle: { color: "white" }
                },
                [_vm._v(_vm._s(_vm.title))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { position: "absolute", right: "0" } },
            [
              _vm.boilerplate || this.$listeners.remove
                ? _c(
                    "v-btn",
                    {
                      attrs: { small: "", icon: "" },
                      on: { click: _vm.handleRemoveClick }
                    },
                    [_c("v-icon", [_vm._v("mdi-minus")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.boilerplate || _vm.storeModal || this.$listeners.fullscreen
                ? _c(
                    "v-btn",
                    {
                      attrs: { small: "", icon: "" },
                      on: { click: _vm.handleFullscreenClick }
                    },
                    [_c("v-icon", [_vm._v("mdi-checkbox-blank-outline")])],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.boilerplate || _vm.storeModal || this.$listeners.close
                ? _c(
                    "v-btn",
                    {
                      attrs: { small: "", icon: "" },
                      on: { click: _vm.handleCloseClick }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "div",
            { staticClass: "overflow-y-auto", style: _vm.height },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "v-row",
            {
              class: { "mr-5": _vm.boilerplate },
              style: `height: ${_vm.POPUP_BOTTOM_HEIGHT}px`,
              attrs: { justify: "end", align: "center" }
            },
            [_vm._t("actions")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }